<c-card *transloco="let t">
    <c-card-body class="px-2">
  
  
        <app-worker-reports-menu></app-worker-reports-menu>
  
        <div class="row">
          <div class="col-sm-8">
            <h3>{{ t('Report: Location Settings') }}</h3>
            <p>{{ t('A list of workers and their app location settings') }}</p>
          </div>
          <div class="col-sm-4 text-end">
            <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>
  
          <div class="card mb-2">
            <div class="card-header"data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">
  
                <form cForm >
  
                  <div class="row d-flex justify-content-center mb-2">
                      <label  class="col-sm-2 col-form-label text-end"  for="monitors">
                        <b>{{ t('Monitor') }}</b>
                      </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="monitors"
                        name="monitor"
                        [(ngModel)]="monitor"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
  
                      <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                        <label  class="col-sm-2 col-form-label text-end" for="groups">
                          <b>{{ t('Group') }}</b>
                        </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="groups"
                        name="group"
                        [(ngModel)]="group"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
                    </ng-container>
  
                    </div>
                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                    </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <div class="col-sm-3">
                      <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                        <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Clear Filter') }}
                        </span>
                      </button>
                    </div>
                </div>
  
                </form>
  
              </div>
            </div>
          </div>
  
          <p>{{ t('Only workers that have installed a version of the OK Alone app are included in this list.') }}</p>
  
          <c-row *ngIf="workers">
            <c-col>
  
              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    <th scope="col">{{ t('Device') }}</th>
                    <th scope="col">{{ t('Location Choice') }}</th>
                    <th scope="col">{{ t('Location Active') }}</th>
                    <th scope="col">{{ t('Note') }}</th>
                    <th scope="col">{{ t('Last Location') }}</th>
                    <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col">{{ t('Groups') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/worker/{{worker.id}}">
                          <svg cIcon class="me-2" name="cil-pencil"></svg>
                          {{ t('Edit') }}
                        </button>
                      </td>
                      <td>
                        <span><b>{{worker.name}}</b></span>
                      </td>
                      <th scope="row">
                        <div>
                          <span class="badge bg-light text-dark">{{worker.pin}}</span>
                        </div>
                      </th>
                      <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td>
                      <td>
                        {{worker.device}}
                      </td>
                      <td class="text-center">
                        <span class="badge fs-5 bg-secondary">{{worker.location_setting}}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge fs-5"  [ngClass]="{'bg-secondary': worker.location_active === 'Unknown', 'bg-success' : worker.location_active === 'Yes', 'bg-warning' : worker.location_active === 'Partial', 'bg-danger' : worker.location_active === 'No' }">{{worker.location_active}}</span>
                      </td>
                      <td [innerHtml]="worker.information | nl2br">
                      </td>
                      <td>
                        {{worker.loc_time}}
                      </td>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.monitors}}</span>
                        </div>
                      </th>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.groups}}</span>
                        </div>
                      </th>
  
                    </tr>
                  </tbody>
  
              </table>
  
            </c-col>
          </c-row>
  
    </c-card-body>
  </c-card>
  
  